import { application } from '@core/controllers/app';

application.register('dtfs-file-processing--consolidations',
  require('./dtfs_file_processing/consolidations_controller').default);
